import React from "react";
import { connect } from "react-redux";
import { Route, Redirect, withRouter } from "react-router-dom";
import Container from "../../components/ContainerComponent";
const ContainerRoute = ({
  component: Component,
  requireHotel,
  hotels,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      requireHotel && hotels.length === 0 ? (
        <Redirect to="/hotel" />
      ) : (
        <Container {...props}>
          <Component {...props} />
        </Container>
      )
    }
  />
);

export default withRouter(
  connect(state => ({ hotels: state.hotels.data }))(ContainerRoute)
);



// WEBPACK FOOTER //
// ./src/utils/helpers/ContainerRoute.js